<script>
import ImageContent from '../image-content/image-content.vue';

export default {
    components: {
        ImageContent,
    }
};
</script>

<template>
    <image-content url="./dc6ba7db237fcd082e01336465feaeef.png" alt="Image"></image-content>
</template>



// WEBPACK FOOTER //
// src/components/image-placeholder/image-placeholder.vue?00e01bd4